module.exports = __webpack_public_path__ + "static/img/51.797fe454.jpeg";